import {FAIL_STORE, SUCCESS_STORE, RESET_MESSAGE_STORE, PENDING_STORE} from '../actions'
import {toast} from 'react-toastify'

const initialState = {
    message : '',
    status: '',
    type: ''
}

export default (state = initialState, action= {})=>{
    switch (action.type) {
        case SUCCESS_STORE:
        
        if(action.message) toast.info(action.message)
            return {
            ...state,
            status: 'success',
            message: action.message,
            messagetype: action.messagetype ? action.messagetype: ''
            }

        case FAIL_STORE:
           if(action.message && !action.messagetype) toast.error(action.message)
            return {
                ...state,
                status: 'fail',
                messagetype: action.messagetype ? action.messagetype: '',
                message: action.message
            }

        case PENDING_STORE:
            return {
                ...state,
                status: 'pending',
                message: action.message
            }
            
            case RESET_MESSAGE_STORE:
            return {
                ...state,
                status: '',
                message: ''
            }
        
    
        default:
            return state;
    }
}